import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=c8b3cada&scoped=true&"
import script from "./NoContent.vue?vue&type=script&lang=js&"
export * from "./NoContent.vue?vue&type=script&lang=js&"
import style0 from "./NoContent.vue?vue&type=style&index=0&id=c8b3cada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b3cada",
  null
  
)

export default component.exports